var $polyfillImages = $('.polyfill-object-fit');
objectFitImages($polyfillImages);
